import { getJson, getList, type PaginationMeta } from '@/lib/api';

/** Rows per page of the log. */
export const PAGE_SIZE = 50;

/**
 * The email log: every email the API tried to send, what it said and what
 * became of it. Admin-only.
 */

export const EMAIL_LOG_STATUS = {
  sent: 'SENT',
  redirected: 'REDIRECTED',
  suppressed: 'SUPPRESSED',
  failed: 'FAILED',
} as const;
export type EmailLogStatus = (typeof EMAIL_LOG_STATUS)[keyof typeof EMAIL_LOG_STATUS];

export interface EmailLogRow {
  readonly id: string;
  readonly to: readonly string[];
  readonly redirectedTo: string | null;
  readonly from: string;
  readonly subject: string;
  readonly status: EmailLogStatus;
  readonly error: string | null;
  readonly source: string;
  readonly relatedToType: string | null;
  readonly relatedTo: string | null;
  readonly attachmentNames: readonly string[];
  readonly sentAt: string;
}

export interface EmailLogDetail extends EmailLogRow {
  readonly replyTo: string | null;
  readonly text: string | null;
  readonly html: string | null;
  readonly providerMessageId: string | null;
}

export interface EmailLogQuery {
  readonly page: number;
  readonly search?: string | undefined;
  readonly status?: EmailLogStatus | undefined;
  readonly sort: string;
  readonly dir: 'asc' | 'desc';
}

export const listEmailLog = (
  query: EmailLogQuery,
  signal?: AbortSignal,
): Promise<{ items: EmailLogRow[]; pagination: PaginationMeta }> =>
  getList<EmailLogRow>(
    '/email-log',
    {
      page: query.page,
      limit: PAGE_SIZE,
      sort: query.sort,
      dir: query.dir,
      ...(query.search ? { search: query.search } : {}),
      ...(query.status ? { status: query.status } : {}),
    },
    signal,
  );

export const readEmailLogEntry = (id: string, signal?: AbortSignal): Promise<EmailLogDetail> =>
  getJson<EmailLogDetail>(`/email-log/${id}`, undefined, signal);
